<template>
  <div class="caster-preview">
    <div
      class="content-mask"
      :style="contentStyle"
      :data-stretchcontent="stretchcontent"
      :data-stretchcontentalign="stretchcontentalign"
    >
      <img
        :src="image"
        alt=""
        v-if="showImage && image !== undefined && image !== ''"
        :style="{ width: '20%', left: '2%', top: '2%', position: 'absolute', opacity: 1, 'z-index': 2000 }"
      >
      <VideoPlayer
        v-if="streamToPlay || hideVideo"
        :streamSrc="streamToPlay"
        :class="cssClasses"
        :id="cefId"
        :volume="'' + volume"
        :sinkMuted="sinkMuted ? 'true' : 'false'"
        :hideVideo="hideVideo"
        :style="{ opacity: opacity }"
        :overwrite_volume="overwriteVolume"
        :chromakey="chromakey"
        :chromakey_screen="chromakeynormalized.screen"
        :chromakey_weight="chromakeynormalized.weight"
        :chromakey_balance="chromakeynormalized.balance"
        :chromakey_clipblack="chromakeynormalized.clipblack"
        :chromakey_clipwhite="chromakeynormalized.clipwhite"
        :animate="true"
        :debugMode="debugMode"
      />
    </div>

    <!-- Caster label SVG -->
    <!--<div v-if="castercss" :style="styles">{{ name }}</div>-->
    <div class="text-wrapper" style="font-size: 125%; ">
      <svg viewBox="0 0 500 150" xmlns="http://www.w3.org/2000/svg" :style="svgStyle">
        <text
          x="50%"
          y="2.5"
          alignment-baseline="hanging"
          text-anchor="middle"
          :fill="styles.color"
          :style="styles"
        >{{ name }}</text>
      </svg>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'
import './CasterPreview.scss'
import helpers from '@/helpers'
import { mapState } from 'vuex'

export default {
  name: 'CasterPreview',
  props: {
    streamToPlay: {
      type: Object
    },
    name: {
      type: String
    },
    user: {
      type: String
    },
    image: {
      type: String
    },
    stretchcontent: {
      type: String,
      default: '' // will be set to any value (eg 'true') if needs to stretch content
    },
    stretchcontentalign: {
      type: String,
      default: ''
    },
    hideVideo: {
      type: Boolean,
      default: false
    },
    debugMode: {
      type: Boolean,
      default: false,
    },
    cefId: {
      type: String
    },
    cefMode: {
      type: String
    },
    volume: {
      type: Number
    },
    sinkMuted: {
      type: Boolean
    },
    opacity: {
      type: Number
    },
    showName: {
      type: Boolean,
      default: true
    },
    showImage: {
      type: Boolean,
      default: true
    },
    castercss: {
      type: Object
    },
    contentStyle: {
      type: Object
    },
    parentHeight: {
      type: Number,
      required: true
    },
    boxWidth: {
      type: Number,
      required: true
    }
  },
  methods: {
    recalcBleeped () {
      try {
        if (this.bleepedStartTime) {
          const timestamp = this.bleepedStartTime
          const dt = (new Date()).getTime() - timestamp - 5000
          if (dt < 0) {
            if (this.recalcBleepedTimer)
              clearInterval(this.recalcBleepedTimer)
            this.recalcBleepedTimer = setTimeout(() => { this.recalcBleeped () }, -dt + 100);
            this.overwriteVolume = 0
            // console.log('this.overwriteVolume MUTE ', this.user, -dt + 100, (new Date()).getTime() / 1000.0)
            return
          }
        }
      } catch (error) {
        console.error('CasterStatus recalcBleeped error ', error)
      }
      this.overwriteVolume = null
      // console.log('this.overwriteVolume UNMUTE', this.user, (new Date()).getTime() / 1000.0)
    }
  },
  mounted () {
    this.recalcBleeped()
  },
  watch: {
    bleeped () {
      this.bleepedStartTime = (new Date()).getTime()
      this.recalcBleeped()
    }
  },
  data: () => ({
      overwriteVolume: null,
      recalcBleepedTimer: null,
      bleepedStartTime: null
  }),
  computed: {
    ...mapState({
      userProfile: state => state.user.profile,
      castTeam: state => state.events.castTeam
    }),
    bleeped () {
      if (this.$store.direct.state.events.currentCast.bleeped &&
          this.user in this.$store.direct.state.events.currentCast.bleeped)
        return this.$store.direct.state.events.currentCast.bleeped[this.user]
      return undefined
    },
    chromakey () {
      let c = null

      let otherprofile = null
      if (this.castTeam) {
        otherprofile = this.castTeam.find(member => { return member.user_id === this.user })
      }

      if (this.streamToPlay && 'name' in this.streamToPlay && this.streamToPlay.name === 'Me' && this.userProfile && this.userProfile.chromakey) {
        c = JSON.parse(JSON.stringify(this.userProfile.chromakey))
      } else if (this.user && this.castTeam && otherprofile && 'chromakey' in otherprofile) {
        c = JSON.parse(JSON.stringify(otherprofile.chromakey))
      } else {
        c = null
      }
      return c
    },
    chromakeynormalized () {
      if (!this.chromakey) {
        return {}
      }

      const c = JSON.parse(JSON.stringify(this.chromakey))
      if ('enabled' in c) {
        if (!c.enabled) {
          c.weight = 0
        }
        delete c.enabled
      }
      for (const key of Object.keys(c)) {
        if (key === 'screen') {
          const color = helpers.hexToRGBA(c.screen)
          c[key] = color.r * 256 * 256 + color.g * 256 + color.b
        } else {
          c[key] /= 100.0
        }
      }
      return c
    },
    cssClasses () {
      let classes = ''
      if (this.cefId !== '') {
        classes += 'ngcvp-sink cef-caster'
      }
      if (this.cefMode === 'front') {
        classes += ' cef-front'
      }
      return classes
    },
    svgStyle () {
      // legacy style was: "text-align: center; margin-top: 0.5em;"
      // the current starting settings are here to mimic the default legacy setting visually
      let labelTopPadding = 0.5
      const css = this.castercss
      if (css?.labelTop) {
        labelTopPadding += parseFloat(css.labelTop)
      }
      const labelTopMargin = labelTopPadding
      // @arnedecant: maybe this is something we needs to revisit. I got this to work with this dirty hack
      // because I cont understand how css works
      // width should be 300px, need to do this in % for some reason
      const widthPercent = 500 / this.boxWidth * 100 * (720 / this.parentHeight)
      return {
        textAlign: 'center',
        marginTop: labelTopMargin + 'em',
        display: (css.labelVisible === false) ? 'none' : 'block',
        position: 'absolute',
        top: '100%',
        width: `${widthPercent}%`,
        zIndex: '1005'
      }
    },
    styles () {
      // NOTE: keep castercss and casterSvgStyle in sync with layoutmanager draggablebox
      const css = this.castercss
      if (!css) {
        return {}
      }

      /* let legacyFontSize = '1em'
      if (css.hasOwnProperty('font-size') && !css.fontSize) {
        legacyFontSize = css['font-size']
      } */
      let legacyFontSize = `${0.03 * this.parentHeight}`
      if (css.fontSize) {
        const fontsize = parseFloat(css.fontSize.replace('rem'))
        legacyFontSize = `${fontsize * 0.03 * this.parentHeight}`
      }
      const labelVisible = (css.labelVisible !== false)

      // console.log('css.fontFamily ', css.fontFamily)
      // console.log('css.fontSize ', css.fontSize )
      // console.log('legacyFontSize ', legacyFontSize )

      const styles = {
        // position: 'absolute',
        // width: '100%',
        color: css.color,
        fontFamily: css.fontFamily || 'beinblack',  // 'beinblack' = legacy default
        fontSize: legacyFontSize,
        display:  (!labelVisible) ? 'none' : 'block',
      }

      // if (css.fontFamily) {
      //   styles.fontFamily = css.fontFamily
      // }
      return styles
    }
  },
  components: {
    VideoPlayer
  }
}
</script>
